import React from "react"
import { Progress, Tooltip } from "antd"

import { EXTERNAL_STATUS_COLORS } from "utils/status"
import Strings from "utils/strings"
import { ORDER_COMPLETION_STATUSES } from "../../Routes/types"
import type { AddressStatus } from "../../Routes/types"

/**
 * How far the courier is through the box: finished orders over the box's total,
 * the delivered share in green and the rest of the finished ones in red.
 */
const BatchProgress: React.FC<{ statuses: (string | undefined)[] }> = ({
	statuses,
}) => {
	const total = statuses.length
	if (total === 0) return null

	const finished = statuses.filter((s) =>
		ORDER_COMPLETION_STATUSES.includes(s as AddressStatus)
	).length
	const delivered = statuses.filter((s) => s === "delivered").length

	return (
		<div className="BatchCard__progress">
			<span className="BatchCard__label">
				{Strings.routes.externalBatchProgress}
			</span>
			<Tooltip
				title={`${Strings.routes.externalDeliveryStatusDelivered}: ${delivered} · ${
					Strings.routes.externalBatchProgressFailed
				}: ${finished - delivered} · ${
					Strings.routes.externalBatchProgressPending
				}: ${total - finished}`}
			>
				<Progress
					className="BatchCard__progress-bar"
					percent={(finished / total) * 100}
					success={{
						percent: (delivered / total) * 100,
						strokeColor: EXTERNAL_STATUS_COLORS.delivered,
					}}
					strokeColor={EXTERNAL_STATUS_COLORS.not_delivered}
					size="small"
					showInfo={false}
				/>
			</Tooltip>
			<span className="BatchCard__progress-count">
				{finished}/{total}
			</span>
		</div>
	)
}

export default BatchProgress
